export const getAntTheme = (theme) => {
  return {
    colorPrimary: theme.palette.primary.main,
    colorTextDescription: theme.palette.text.secondary,
    colorLink: theme.palette.primary.main,
    colorText: theme.palette.text.primary,
    fontFamily: theme.font.family,
    colorBgContainer: theme.palette.background.container,
    colorBgElevated: theme.palette.background.container,
    colorTextPlaceholder: theme.palette.background.secondary,
    colorBorder: theme.palette.borderColor.default,
    colorFillAlter: theme.palette.background.authCard,
  };
};


